import { Tooltip as AntTooltip } from "antd";
import PropTypes from "prop-types";

const Tooltip = ({ children, ...rest }) => (
  <AntTooltip overlayClassName="custom-tooltip" {...rest}>
    {children}
  </AntTooltip>
);

Tooltip.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
  getPopupContainer: PropTypes.func,
};

export default Tooltip;
